import { useAuthStore } from '@/store/authStore';
import { useEffect } from 'react';

interface LogoutMessage {
  type: 'CROSS_APP_LOGOUT';
  source: 'v2' | 'v3';
}

export const CrossAppLogoutListener: React.FC = () => {
  const logout = useAuthStore((state) => state.logout);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const data = event.data as LogoutMessage;

      // Simple validation - only check if it's a logout message
      if (data?.type === 'CROSS_APP_LOGOUT') {
        console.log('Received logout message from v2, logging out v3');
        logout();
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [logout]);

  return <div>Cross App Logout</div>; // This component doesn't render anything
};
